import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M559.706,1575.941 L1919.706,1575.941 L1919.706,1455.941 L559.706,1455.941 L559.706,1575.941 Z M559.706,454.941 L1919.706,454.941 L1919.706,334.941 L559.706,334.941 L559.706,454.941 Z M559.706,1015.941 L1919.706,1015.941 L1919.706,895.941 L559.706,895.941 L559.706,1015.941 Z M169.5,565 C75.888,565 0,489.112 0,395.5 C0,301.888 75.888,226 169.5,226 C263.112,226 339,301.888 339,395.5 C339,489.112 263.112,565 169.5,565 L169.5,565 Z M169.5,481 C216.72,481 255,442.72 255,395.5 C255,348.28 216.72,310 169.5,310 C122.28,310 84,348.28 84,395.5 C84,442.72 122.28,481 169.5,481 L169.5,481 Z M169.5,1689 C75.888,1689 0,1613.112 0,1519.5 C0,1425.888 75.888,1350 169.5,1350 C263.112,1350 339,1425.888 339,1519.5 C339,1613.112 263.112,1689 169.5,1689 L169.5,1689 Z M169.5,1605 C216.72,1605 255,1566.721 255,1519.5 C255,1472.279 216.72,1434 169.5,1434 C122.28,1434 84,1472.279 84,1519.5 C84,1566.721 122.28,1605 169.5,1605 L169.5,1605 Z M169.5,1127 C75.888,1127 0,1051.112 0,957.5 C0,863.888 75.888,788 169.5,788 C263.112,788 339,863.888 339,957.5 C339,1051.112 263.112,1127 169.5,1127 L169.5,1127 Z M169.5,1043 C216.72,1043 255,1004.721 255,957.5 C255,910.28 216.72,872 169.5,872 C122.28,872 84,910.28 84,957.5 C84,1004.721 122.28,1043 169.5,1043 L169.5,1043 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconBulletListCircleOutlineLine = /*#__PURE__*/function (_Component) {
  _inherits(IconBulletListCircleOutlineLine, _Component);

  var _super = _createSuper(IconBulletListCircleOutlineLine);

  function IconBulletListCircleOutlineLine() {
    _classCallCheck(this, IconBulletListCircleOutlineLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconBulletListCircleOutlineLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconBulletListCircleOutline",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconBulletListCircleOutlineLine.displayName = "IconBulletListCircleOutlineLine";
  return IconBulletListCircleOutlineLine;
}(Component);

IconBulletListCircleOutlineLine.glyphName = 'bullet-list-circle-outline';
IconBulletListCircleOutlineLine.variant = 'Line';
IconBulletListCircleOutlineLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconBulletListCircleOutlineLine;
export { IconBulletListCircleOutlineLine };